import Layout from '../../internal/Layout.vue'
import StandardEquipamentPages from './standardEquipment.vue'

const StandardEquipamentRoutes = {
  component: Layout,
  children: [
    {
      name: 'standardEquipment',
      path: '/standardEquipments',
      props: (route) => ({ all: route.query.all }),
      component: StandardEquipamentPages,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresSupervisor: true,
        requiresAdmin: true,
      },
    },
  ],
}

export default StandardEquipamentRoutes
